import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { tampleteCreateRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useCreateTemplateProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useCreateTemplate = ({
    setErrorText = () => { },
}: useCreateTemplateProps) => {
    const client = useQueryClient();

    const { mutate: createTemplate, isLoading: isCreatingTemplate } =
        useMutation({
            mutationFn: (variables:
                {
                    template_name: string
                    template_description?: string
                    status?: number
                    company_id?: number | string
                    payment_method?: number
                    apply_changes: boolean
                }) =>
                axiosInstance
                    .post(tampleteCreateRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([templateList]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        createTemplate,
        isCreatingTemplate,
    };
};
